import { initialQuote, type IntakeQuoteView, type ProductionType } from "./intake-source-store";
export interface IntakeCreditQuote {
  scene_count: number;
  production_type: ProductionType;
  estimated_credits?: number;
  image_estimated_credits?: number;
  motion_estimated_credits?: number;
  motion_scene_count?: number;
  maximum_credits?: number | null;
  route_configured?: boolean;
  within_limit?: boolean;
  provider_configured?: boolean;
  motion_provider_configured?: boolean;
  quote_id?: string;
  message?: string;
}
export interface IntakeReadiness {
  ready: boolean;
  stale: boolean;
  missing: readonly unknown[];
  semanticReady: boolean;
  manualStory: boolean;
}
/** Before Iris has written anything; while chatting the form shows "Talk with Iris first" instead. */
export const NO_DRAFT_LABEL = "Fill the production form first";
// The one-click first cut fixes Iris's outfit for every cast member without one, so the first film keeps the clothes.
const FIRST_CUT_OUTFITS = "If a cast member has no fixed clothing yet, Iris fixes one outfit per cast member for the first cut (a few cents of text-model credit).";

export function intakeQuoteView(quote: IntakeCreditQuote | null, count: number, type: ProductionType, ai: boolean, hasDraft: boolean, intake: IntakeReadiness): IntakeQuoteView {
  const motion = type === "motion_music_video";
  const label = !hasDraft ? NO_DRAFT_LABEL : intake.missing.length ? `Complete ${intake.missing.length} required ${intake.missing.length === 1 ? "field" : "fields"}` : !intake.semanticReady && !intake.manualStory ? "Retry Caprica AI story writer" : "Approve form & create production · 0 credits →";
  const result = { ...initialQuote(), hidden: ai && !intake.ready, label: ai ? label : "Checking credits...", disabled: ai ? !intake.ready : true };
  if (intake.stale) return { ...result, hidden: true, disabled: true, label: "Update the story after changing choices" };
  if (!quote || Number(quote.scene_count) !== count || quote.production_type !== type) return { ...result, total: "Checking future production credits...", message: ai ? "Talking and form review use 0 customer credits. The first generation estimate appears here before approval." : result.message };
  const ready = quote.route_configured === true && quote.within_limit === true && !!quote.quote_id;
  return {
    ...result,
    total: `${Number(quote.estimated_credits || 0)} credits estimated`,
    scope: `${Number(quote.image_estimated_credits || 0)} credits now · ${count} frames`,
    motion: motion ? `${Number(quote.motion_estimated_credits || 0)} credits estimated · ${Number(quote.motion_scene_count || count)} shots` : "0 credits · elegant local movement",
    limit: !ready ? quote.provider_configured === false ? "Production image provider unavailable" : motion && quote.motion_provider_configured === false ? "Motion provider unavailable" : `Above ${Number(quote.maximum_credits || 0)}-credit server limit` : quote.maximum_credits == null ? "Server safety guard active" : `Route stays within the ${Number(quote.maximum_credits)}-credit server ceiling`,
    message: ai ? "This is the first real production estimate. Nothing is generated until you approve the form and continue." : `${quote.message || "Credits are confirmed only when you create this first cut."} ${FIRST_CUT_OUTFITS}`,
    disabled: ai ? !intake.ready : !ready,
    label: ai ? label : ready ? motion ? `Create motion plan · ${Number(quote.image_estimated_credits || 0)} credits now →` : `Create lyric first cut · ${Number(quote.image_estimated_credits || 0)} credits →` : "Selected route unavailable",
  };
}
